export enum Size {
    Low = 'low',
    Med = 'med',
    High = 'high',
    VeryHigh = 'veryHigh',
}
